import { Action, Seo } from '@portfolio/models'
import { getLocaleRegionIdFromPath } from '@portfolio/utils'
import { groq } from 'next-sanity'
import { getClient } from './getClient'
import { coalesceLocaleField } from './helpers/coalesceLocaleField'
import { createBaseImageProjection } from './projections/createBaseImageProjection'
import { createSEOProjection } from './projections/createSEOProjection'

export type AiLabPageResult = {
  seo: Seo | null
  contactAction: Action
}

export async function getAiLabPage({
  locale,
  preview = false,
}: {
  locale: string
  preview?: boolean
}): Promise<AiLabPageResult> {
  const [, localeId] = getLocaleRegionIdFromPath(locale)
  const BASE_IMAGE_PROJECTION = createBaseImageProjection(localeId)

  const query = groq`{
    "seo": *[_type == 'aiLab'][0].seo${createSEOProjection(localeId)},
    "socials": *[_type == "socials"]{
      items[]{
        url,
        logoLight${BASE_IMAGE_PROJECTION},
        logoDark${BASE_IMAGE_PROJECTION},
      }
    }[0],
    "contactForm": *[_type == "contactForm"] {
      ${coalesceLocaleField('formTitle', localeId)},
      ${coalesceLocaleField('emailTitle', localeId)},
      contactEmail -> {${coalesceLocaleField('email', localeId)}},
    }[0]
  }`

  const result = await getClient(preview).fetch(query)

  return {
    seo: result?.seo ?? null,
    contactAction: {
      type: 'contactFormModal',
      payload: {
        crmContext: 'AI Lab page',
        socials: result?.socials,
        contactForm: result?.contactForm,
      },
    },
  }
}
